import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
    },
    secondary: {
      main: '#dc004e',
      light: '#f50057',
      dark: '#c51162',
    },
    background: {
      default: '#000000',
      paper: '#36454F',
      elevated: '#4c6a7b',
      subtle: '#2d3a42',
    },
    text: {
      primary: '#D3D3D3',
      secondary: '#F5F5F5',
      disabled: '#888888',
    },
    action: {
      active: '#4c6a7b',
      hover: '#f0f2f7',
      selected: '#5a7a8e',
      focus: '#00F3FF',
      disabled: '#555555',
      disabledBackground: '#333333',
    },
    success: {
      main: '#4caf50',
      light: '#81c784',
      dark: '#388e3c',
    },
    warning: {
      main: '#ff9800',
      light: '#ffb74d',
      dark: '#f57c00',
    },
    error: {
      main: '#f44336',
      light: '#e57373',
      dark: '#d32f2f',
    },
    info: {
      main: '#2196f3',
      light: '#64b5f6',
      dark: '#1976d2',
    },
  },
  spacing: 8, // Base spacing unit
  shape: {
    borderRadius: 6,
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
    h1: {
      color: '#F5F5F5',
      fontSize: '2.5rem',
      fontWeight: 700,
    },
    h2: {
      color: '#F5F5F5',
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      color: '#F5F5F5',
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    h4: {
      color: '#F5F5F5',
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      color: '#F5F5F5',
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      color: '#F5F5F5',
      fontSize: '1rem',
      fontWeight: 800,
    },
    body1: {
      color: '#D3D3D3',
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body2: {
      color: '#D3D3D3',
      fontSize: '0.875rem',
      lineHeight: 1.43,
    },
    caption: {
      color: '#888888',
      fontSize: '0.75rem',
      lineHeight: 1.66,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  transitions: {
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195,
    },
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#f0f2f7',
          borderColor: 'black',
          borderRadius: 6,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            borderColor: 'whitesmoke',
            transform: 'translateY(-1px)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
          },
          '&:active': {
            transform: 'translateY(0)',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'scale(1.05)',
          },
          '&:active': {
            transform: 'scale(0.95)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 6,
            '&:hover fieldset': {
              borderColor: '#4c6a7b',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#00F3FF',
            },
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#2d3a42',
          color: '#F5F5F5',
          fontSize: '0.75rem',
          borderRadius: 6,
          padding: '8px 12px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.5)',
        },
        arrow: {
          color: '#2d3a42',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          backgroundImage: 'none',
        },
        elevation1: {
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        },
        elevation2: {
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.25)',
        },
        elevation3: {
          boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',
        },
      },
    },
  },
});

export default theme;
